export default __webpack_public_path__ + "static/media/stoppo.b6c31e30.svg";